import { OnInit } from '@angular/core/';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

import { environment } from 'environments/environment';

import { ConstantsService } from 'app/services/constants-service';
import { EntityOtherComponent } from 'app/entities/other/entity-other.component';
import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { EntityDetailsService } from 'app/entities/details/entity-details.service';
import { EntityOtherService } from 'app/entities/other/entity-other.service';
import { EntityCafService } from 'app/entities/caf/entity-caf.service';
import { SurveyInstance } from 'app/entities/surveys/survey-instance.model';

@Component({
  templateUrl: './entity-caf.component.html'
})

export class EntityCafComponent extends EntityOtherComponent implements OnInit {
  entityIdDetails: EntityIdDetails;
  surveyInstances: SurveyInstance[];

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public domSanitizer: DomSanitizer,
    public entityDetailsService: EntityDetailsService,
    public entityOtherService: EntityOtherService,
    private entityCafService: EntityCafService) {
    super(route, router, domSanitizer, entityDetailsService, entityOtherService);
  }

  ngOnInit() {
    this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();
    this.entityDetailsService.entityDetailsUpdated.subscribe(
      (entityDetails) => {
        this.entityIdDetails = entityDetails;
      }
    );
    if (this.entityIdDetails.entityId) {
      this.loadSurveyInstances();
    }
  }

  loadSurveyInstances() {
    this.entityCafService.getSurveyDetails(this.entityIdDetails.entityId)
      .subscribe(response => {
        this.surveyInstances = response;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/caf/entity-caf.component.ts